import { TargetScoreRangeTemplate } from '../..';

export function getTemplatesSansFirmDefaults(templates: TargetScoreRangeTemplate[]) {
  return templates.filter((template) => !template.firmDefaults);
}
